import React from 'react';
import Seperator from '../seperator';
export default function SecurityCode({
  securityCode
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "card-security-ribbon"
  }, /*#__PURE__*/React.createElement(Seperator, {
    classes: "card-security-code",
    seperator: false
  }, securityCode));
}